/**
 * Application metadata
 */
export const APP_NAME = 'NoMiss';
export const APP_VERSION = '1.0.0';
export const APP_DESCRIPTION = 'Your sport, your time, your choice';

/**
 * Local storage keys
 */
export const LOCAL_STORAGE_KEYS = {
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
  KYC_VERIFICATION_ID: 'kyc_verification_id',
} as const;

/**
 * Session storage keys
 */
export const SESSION_STORAGE_KEYS = {
  REDIRECT_URL: 'redirect_url',
  FORM_DATA: 'form_data',
} as const;

/**
 * Cookie names
 */
export const COOKIE_NAMES = {
  AUTH_TOKEN: 'x-access-token',
  REFRESH_TOKEN: 'x-refresh-token',
  CONSENT: 'cookie_consent',
} as const;

/**
 * Breakpoints (in pixels)
 */
export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
  WIDE: 1280,
  ULTRA_WIDE: 1536,
} as const;

/**
 * Timeouts (in milliseconds)
 */
export const TIMEOUTS = {
  API_REQUEST: 30000,
  DEBOUNCE: 300,
  TOAST: 2000,
  TOOLTIP: 200,
} as const;

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
} as const;

/**
 * Default country code for phone inputs
 */
export const DEFAULT_COUNTRY_CODE = '+91';
